import { Modal, Button } from "react-bootstrap";

function VoidConfirmationModal({ show, onClose, onYesClick }) {
  return (
    <Modal show={show} onHide={onClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Void</Modal.Title>
      </Modal.Header>
      <Modal.Body>Are you sure you want to void this order?</Modal.Body>
      <Modal.Footer>
        <Button data-delivery-id variant="primary" onClick={onYesClick}>
          Yes
        </Button>
        <Button variant="secondary" onClick={onClose}>
          No
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default VoidConfirmationModal;
